import React from 'react';
import { Backpack, GraduationCap, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

const PreDepartureDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Pre-Departure</h1>
              <p className="text-gray-600 mt-1">Get ready for your journey abroad</p>
            </div>
            <Link to="/services" className="px-4 py-2 text-sm text-teal-600 hover:text-teal-700 font-medium transition-colors">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200">
            <div className="bg-teal-100 p-3 rounded-lg w-fit mb-4 group-hover:bg-teal-600 transition-colors">
              <Backpack className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-teal-600 transition-colors">Checklist</h3>
            <p className="text-sm text-gray-600 mt-2">Complete your pre-departure tasks</p>
          </div>
          <div className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200">
            <div className="bg-teal-100 p-3 rounded-lg w-fit mb-4 group-hover:bg-teal-600 transition-colors">
              <GraduationCap className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-teal-600 transition-colors">Orientation</h3>
            <p className="text-sm text-gray-600 mt-2">Attend pre-departure sessions</p>
          </div>
          <div className="group bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 p-6 border border-gray-100 hover:border-teal-200">
            <div className="bg-teal-100 p-3 rounded-lg w-fit mb-4 group-hover:bg-teal-600 transition-colors">
              <BookOpen className="w-6 h-6 text-teal-600 group-hover:text-white transition-colors" />
            </div>
            <h3 className="font-semibold text-lg text-gray-900 group-hover:text-teal-600 transition-colors">Resources</h3>
            <p className="text-sm text-gray-600 mt-2">Access helpful guides and tips</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Pre-Departure Checklist</h2>
          <p className="text-gray-600">Interactive checklist and orientation sessions coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default PreDepartureDashboard;
